import React, { Component } from "react";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { Status, LocaleLink, Button } from "../../../common/";
import I18n from "../../../../i18n/I18n";
import Helper from "../../../../helper/Helper";
import styles from "../../../orders/orderTable/OrderTable.scss";

const DisputeRow = props => {
  const { item, searchString, property } = props;
  return (
    <tr className={styles.row}>
      {property.haveTicketNr ? (
        <td>
          <LocaleLink to={`/disputes/ticket/${item.ticket_nr}`}>
            <Button variant="asn" className={styles.asnBtn}>
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={item.ticket_nr}
              />
            </Button>
          </LocaleLink>
        </td>
      ) : (
        ""
      )}

      {property.haveVal("dispute_type") ? (
        <td>
          <Highlighter
            highlightClassName={styles.highlight}
            searchWords={[searchString]}
            autoEscape={true}
            textToHighlight={item.dispute_type}
          />
        </td>
      ) : (
        ""
      )}

      {property.haveVal("ref_to") ? (
        <td>
          {item.ref_to ? (
            <LocaleLink
              to={`/transfers/${
                item.dispute_type === "RETURN" ? "rtv" : "asn"
              }/${item.ref_to}`}
              className={styles.viewMoreBtn}
            >
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={item.ref_to}
              />
            </LocaleLink>
          ) : (
            ""
          )}
        </td>
      ) : (
        ""
      )}

      {property.haveVal("created_at") ? (
        <td>
          {item && item.created_at
            ? moment(item.created_at).format(`YYYY-MM-DD`)
            : "-"}
        </td>
      ) : (
        ""
      )}
      {property.haveVal("dispute_reason") ? <td>{item.dispute_reason}</td> : ""}

      {property.haveVal("closed_at") ? (
        <td>
          {item && item.closed_at
            ? moment(item.closed_at).format(`YYYY-MM-DD`)
            : "-"}
        </td>
      ) : (
        ""
      )}

      {property.haveVal("status") ? (
        <td>
          <Status status={item.status} />
        </td>
      ) : (
        ""
      )}

      <td>
        {item.resolution_amount && item.currency_code
          ? I18n.formatCurrency(
              Helper.formatPrice(item.resolution_amount, item.currency_code)
            )
          : I18n.getText("disputes.unpaid")}
      </td>

      <td />
    </tr>
  );
};

export default DisputeRow;



// WEBPACK FOOTER //
// ./src/components/disputes/disputesTable/disputesRow/DisputesRow.js